export function useBookingUrl(): string {
  return '/booking';
}
